export const messages = {
  description: {
    id: 'admin/promotions.form.buy-and-win.benefit.title',
  },
  empty: {
    description: {
      id: 'admin/promotions.form.regular.benefit.title',
    },
    add: {
      id: 'admin/promotions.form.regular.view.empty.benefit.add',
    },
    discount: {
      id: 'admin/promotions.form.regular.view.benefit.discount',
    },
    nominal: {
      id: 'admin/promotions.form.regular.view.benefit.nominal',
    },
    percentual: {
      id: 'admin/promotions.form.regular.view.benefit.percentual',
    },
    formula: {
      id: 'admin/promotions.form.regular.view.benefit.discount.formula',
    },
    shipping: {
      id: 'admin/promotions.form.regular.view.benefit.shipping',
    },
    nominalShipping: {
      id: 'admin/promotions.form.regular.view.benefit.nominal',
    },
    percentualShipping: {
      id: 'admin/promotions.form.regular.view.benefit.percentual',
    },
    freeShipping: {
      id: 'admin/promotions.form.regular.view.benefit.shipping.free',
    },
    maxShipping: {
      id: 'admin/promotions.form.regular.view.benefit.shipping.max',
    },
    maxPrice: { id: 'admin/promotions.form.regular.view.benefit.max-price' },
    gift: { id: 'admin/promotions.form.regular.view.benefit.gift' },
    loyalty: {
      id: 'admin/promotions.form.regular.view.benefit.loyalty',
    },
    nominalLoyalty: {
      id: 'admin/promotions.form.regular.view.benefit.nominal',
    },
    percentualLoyalty: {
      id: 'admin/promotions.form.regular.view.benefit.percentual',
    },
    priceTable: {
      id: 'admin/promotions.form.regular.view.benefit.price-table',
    },
  },
}
